import { lazy } from 'react';
/** Открывает поиск заданий */
export const TaskIndexPageAsync = lazy(() => import('./TaskIndex/TaskIndexPage'));